<template>
  <div class="">{{ $t('finance.invoiceView.viewInvoice') }}</div>
</template>

<script>
export default {
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>
  
</style>